<template>
    <div class="share-this uk-width-1-1">
        <h4 class="uk-text-sidebar-title uk-margin-small-bottom">{{ $t("message.share_this") }}</h4>
        <div class="uk-card-body uk-card-light-gray share-block">
            <div class="uk-grid uk-grid-xsmall" :class="containerClass" uk-grid>
                <div>
                    <a :href="'https://www.linkedin.com/shareArticle?mini=true&url=' + encoded_link"
                        class="uk-button-social"
                        onclick="shareThis(this.href); return false;" rel="nofollow" target="_blank">
                        <span uk-icon="icon: linkedin; ratio: 0.75"></span>
                    </a>
                </div>
                <div>
                    <a :href="'https://twitter.com/intent/tweet?url=' + encoded_link + '&text=' + encoded_title"
                        class="uk-button-social"
                        onclick="shareThis(this.href); return false;" rel="nofollow" target="_blank">
                        <span uk-icon="icon: x; ratio: 0.75"></span>
                    </a>
                </div>
                <div>
                    <a :href="'mailto:?subject=' + encoded_title + '&body=Hello,%0A %0A I found this at datarobot.com and thought you might be interested. Take a look here: ' + encoded_link + '%0A %0A Thank you.'"
                        class="uk-button-social"
                        rel="nofollow" target="_blank">
                        <span uk-icon="icon: mail; ratio: 0.75"></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'ShareThis',
    props: {
        link: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        containerClass: {
            type: String,
            default: ''
        }
    },
    computed: {
        encoded_link: function() {
            return encodeURIComponent(this.link);
        },
        encoded_title: function() {
            return encodeURIComponent(this.title);
        }
    },
    created: function() {},
    mounted: function () {},
    beforeDestroy: function () {}
  };
</script>